import React, { useState } from "react";
import { Badge, Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { MdAttachFile } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../../../context/AuthContext";
import HoverBadge from "../../shared/HoverBadge";

/**
 * Body Stage
 * 
 * @param {customer} props bool if customer
 * @param {body} props string setter
 * @param {setFiles} props list setter for files
 * @param {about} props string ticket about
 * @param {invoice} props string invoice type
 * @param {building} props object/bool selected building
 * @param {setStage} props string setter to set stage
 * 
 * @returns gui
 */
const BodyTicketStage = (props) => {

    const { user } = useAuthState();
    const [enteredBadge, setEnteredBadge] = useState(false);
    const [bodyField, setBodyField] = useState(""); // textarea field
    const [fileList, setFileList] = useState([]); // list of files to be uploaded
    const navigate = useNavigate();

    // function to add file to list
    const addFileToList = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var tempList = [...fileList];
            if (tempList.length < 8) {
                var index = tempList.findIndex(i => i.file_name === file.name);
                if (index === -1) tempList.push({file_name: file.name, file: reader.result.split(",")[1]});
                setFileList(tempList);
            }
        }
    }

    // function to remove file from list
    const removeFileFromList = (fileName) => {
        var tempList = fileList.filter(file => file.file_name !== fileName);
        setFileList(tempList);
        setEnteredBadge(false);
    }

    // back button handler
    const backBtnHandler = () => {
        // props.invoice === "Energielieferant"? props.setStage('energielieferant') : props.invoice === "Poolrechnung" ? props.setStage("invoiceNum") : props.about === "Energieliefervertrag"? props.setStage("Energieliefervertrag") : props.setStage("default")
        if (props.state !== undefined && props.state !== null) {
            if (user.x_is_house_management) {
                return navigate(`/hw/dashboard/energieliefervertraege/${props.state.object.id}/`);
            } else {
                return navigate(`/dashboard/energieliefervertraege/${props.state.object.id}/`)
            }
        }
        if (props.building === true) {
            return props.setStage("buildings");
        }
        if (props.about === "Energieliefervertrag") return props.setStage("Energieliefervertrag");
        if (props.invoice === "Energielieferant") return props.setStage("energielieferant");
        if (props.invoice === "Poolrechnung") return props.setStage("poolrechnung");

        props.setStage("default");
    }

    // GUI
    return (
        <>
            <h5>Geben Sie Ihre Nachricht ein</h5>
            <Row className="mt-4">
                <Col xs="12">
                    <FloatingLabel label="Nachricht">
                        <Form.Control
                            onChange={e => setBodyField(e.target.value)}
                            value={bodyField}
                            as="textarea"
                            placeholder="Nachricht"
                            style={{height: "150px"}}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs="12">
                    <input 
                        type="file" 
                        name="attachment" 
                        id="attachment"
                        hidden 
                        onChange={e => addFileToList(e.target.files[0])}
                    />
                    <a
                        onClick={e => {e.preventDefault(); document.getElementById('attachment').click()}}
                        href="anhängen/"
                        className="link-energo"
                    >
                        <MdAttachFile size={25} /> Datei anhängen
                    </a>
                    <small style={{marginLeft: "5px"}}>Maximal 8 Anhänge erlaubt</small>
                </Col>
            </Row>
            {fileList.length > 0 ?
                <Row className="mt-3">
                    <Col xs="12">
                        {fileList.map(f => (
                            <small>
                                <HoverBadge
                                    id={f.file_name}
                                    desc={f.file_name}
                                    remove={() => removeFileFromList(f.file_name)}
                                />
                            </small>
                        ))}
                    </Col>
                </Row>
            :null}
            <Row className="mt-5">
                <Col xs="12" className="text-end">
                    <Button
                        onClick={() => backBtnHandler()}
                        variant="warning"
                        style={{marginRight: "5px"}}
                    >
                        Zurück
                    </Button>
                    <Button 
                        onClick={() => {props.body(bodyField); props.setFiles(fileList); props.customer? props.setStage("summarize"): props.setStage("users")}}
                        hidden={bodyField.length < 3}
                        className="btn-energo"
                    >Weiter</Button>
                </Col>
            </Row>
        </>
    )
}

export default BodyTicketStage;